import { render, staticRenderFns } from "./WorklistColumns.vue?vue&type=template&id=6737c246&scoped=true"
import script from "./WorklistColumns.vue?vue&type=script&lang=js"
export * from "./WorklistColumns.vue?vue&type=script&lang=js"
import style0 from "./WorklistColumns.vue?vue&type=style&index=0&id=6737c246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6737c246",
  null
  
)

export default component.exports